import { motion } from "framer-motion";
import { Bed, Coffee, Sandwich, UtensilsCrossed, IndianRupee } from "lucide-react";

const items = [
  { icon: Bed, label: "Bed" },
  { icon: Coffee, label: "Breakfast" },
  { icon: Sandwich, label: "Lunch" },
  { icon: UtensilsCrossed, label: "Dinner" },
];

const USPSection = () => {
  return (
    <section className="bg-secondary py-12 md:py-16 relative overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-primary/10 rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-24 h-24 bg-primary/10 rounded-full translate-x-1/2 translate-y-1/2" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          {/* Main headline */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-6">
            {items.map((item, index) => (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="flex items-center gap-2"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary flex items-center justify-center">
                  <item.icon className="w-5 h-5 md:w-6 md:h-6 text-primary-foreground" />
                </div>
                <span className="text-lg md:text-xl font-semibold text-secondary-foreground">
                  {item.label}
                </span>
                {index < items.length - 1 && (
                  <span className="text-2xl text-primary font-bold ml-2">+</span>
                )}
              </motion.div>
            ))}
          </div>

          {/* Price highlight */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 md:px-8 py-3 md:py-4 rounded-full shadow-xl"
          >
            <span className="text-lg md:text-xl font-medium">Starting from just</span>
            <div className="flex items-center">
              <IndianRupee className="w-6 h-6 md:w-8 md:h-8" />
              <span className="text-3xl md:text-5xl font-bold">499</span>
            </div>
            <span className="text-lg md:text-xl font-medium">/night</span>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.6 }}
            className="mt-6 text-secondary-foreground/70 text-lg max-w-xl mx-auto"
          >
            All-inclusive stays with no hidden charges. Your perfect home away from home.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default USPSection;
